module.exports = __webpack_public_path__ + "img/logo_mobile_text.71d48218.png";